/* eslint-disable no-unused-vars */
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Breadcrumbs, Button, Container, Grid, Link, Typography } from '@mui/material';
import * as React from 'react';
import { CampaignStats } from '../../components/campagne';
import { useTheme } from '@mui/material/styles';
import useAuth from '../../hooks/useAuth';
import ChevronRightIcon from '../../icons/ChevronRight';
import PlusIcon from '../../icons/Plus';
import CampaignIcon from '@mui/icons-material/Campaign';
import { alpha } from '@mui/material/styles';
import { darkVeil, grey } from '../../theme/tones';
import usePermissions from '../../hooks/usePermissions';

const Campagnes = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const { can } = usePermissions();

  return (
    <>
      <Helmet>
        <title>Tableau de bord: Campagnes | Syndays</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4
        }}
      >
        <Container maxWidth={false} disableGutters sx={{ px: 2 }}>
          {/* ── Hero Header ── */}
          <Box
            sx={{
              mb: 4,
              p: 3.5,
              borderRadius: '24px',
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.paper',
              backdropFilter: 'blur(20px)',
              boxShadow: theme.palette.mode === 'light'
                ? `0 4px 24px ${darkVeil(0.04)}`
                : `0 4px 24px ${darkVeil(0.2)}`,
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-start', md: 'center' },
              justifyContent: 'space-between',
              gap: 3,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: '16px',
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: (theme) => `0 8px 20px ${alpha(theme.palette.secondary.main, 0.3)}`,
                  flexShrink: 0,
                }}
              >
                <CampaignIcon sx={{ color: grey(0), fontSize: '1.7rem' }} />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: '1.5rem',
                    color: 'text.primary',
                    letterSpacing: '-0.02em',
                    lineHeight: 1.2,
                  }}
                >
                  Campagnes
                </Typography>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<ChevronRightIcon fontSize="small" />}
                  sx={{ mt: 1 }}
                >
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/dashboard"
                    variant="subtitle2"
                    sx={{ textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}
                  >
                    Tableau de bord
                  </Link>
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/dashboard"
                    variant="subtitle2"
                    sx={{ textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}
                  >
                    Gestion
                  </Link>
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                    sx={{ fontWeight: 600 }}
                  >
                    Campagnes
                  </Typography>
                </Breadcrumbs>
              </Box>
            </Box>

            {can('campaign.create', user.access_level === 0) && (
              <Button
                component={RouterLink}
                to="/dashboard/campaign/create"
                variant="contained"
                startIcon={<PlusIcon fontSize="small" />}
                sx={{
                  borderRadius: '12px',
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: '0.88rem',
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                  color: grey(0),
                  boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.secondary.main, 0.25)}`,
                  '&:hover': {
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                    boxShadow: (theme) => `0 6px 16px ${alpha(theme.palette.secondary.main, 0.35)}`,
                    transform: 'translateY(-1px)',
                  },
                  transition: 'all 0.2s ease-in-out',
                  px: 2.5,
                  py: 1.2,
                }}
              >
                Nouvelle campagne
              </Button>
            )}
          </Box>
          <Grid>
            <CampaignStats />
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Campagnes;
